export const achievementTileStyles = `
  .qad-root {
    position: relative;
    box-shadow: var(--shadow-pill);
    border-radius: var(--rad-catchup-medium);
    z-index: 0;
    margin-left: 0.25rem;
    background-color: var(--catchup-white);
  }
  .qad-grayscale {
    filter: grayscale(100%);
  }
  .qad-size-xsmall {
    width: 1rem;
  }
  .qad-size-small {
    width: 1.5rem;
  }
  .qad-size-medium {
    width: 2rem;
  }
  .qad-size-large {
    width: 2.5rem;
  }
  .qad-size-xlarge {
    width: 3rem;
  }
  .qad-size-2xlarge {
    width: 4rem;
  }
  .qad-size-3xlarge {
    width: 5rem;
  }
  .qad-size-4xlarge {
    width: 6rem;
  }
  .qad-size-5xlarge {
    width: 8rem;
  }
  .qad-size-6xlarge {
    width: 10rem;
  }
  .qad-size-7xlarge {
    width: 12rem;
  }
  .qad-size-8xlarge {
    width: 14rem;
  }
  .qad-overlay-mid {
    position: absolute;
    z-index: 10;
  }
  .qad-overlay-top {
    position: absolute;
    z-index: 20;
  }
  .qad-image-fill {
    width: 100%;
    height: 100%;
  }
`;
